
export enum StepEvent {
    Finishing = "finishing",
}
